module.exports = __webpack_public_path__ + "img/aeroland-digital-store-product-02.0306d421.jpg";